import {biLogger, getOrigin, HP_VERSION} from './bi-logger';
import experiments from './experiments';
import webBiLogger from '@wix/web-bi-logger';
import createHpLogger, {Logger as BiLoggerHp} from '@wix/bi-logger-hp';

let hpLoggerNoBeacon: BiLoggerHp;

export const reportClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
  const button = e.currentTarget;
  const biData = {
    fold_name: button.getAttribute('data-foldname'),
    origin: getOrigin(),
    version: HP_VERSION
  };

  if (String(experiments.get('specs.EnableBiBeaconOnWixHP')) === 'true') {
    biLogger.getLogger('hp').clickOnStartNow(biData);
  } else {
    if (!hpLoggerNoBeacon) {
      hpLoggerNoBeacon = createHpLogger(webBiLogger)({
        useBeacon: false
      });
    }
    hpLoggerNoBeacon.clickOnStartNow(biData);
    setTimeout(() => {
      window.location.assign(button.href);
    }, 100);
    e.preventDefault();
  }
};

export const reportSecondaryCtaClick = (button: HTMLElement) => {
  biLogger.getLogger('hp').hpSecondaryCta({
    fold_name: button.getAttribute('data-foldname'),
    message: button.getAttribute('data-message')
  });
};

export const reportGalleryItemClick = (e: React.MouseEvent<HTMLAnchorElement>) => biLogger.getLogger('hp').hpSecondaryCta({
  additional_info: e.currentTarget.href,
  fold_name: 'gallery',
});
